export default "__VITE_ASSET__lEn6qgi___"